// src/features/auth/components/ForgotPasswordForm.js
import React from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Link } from 'react-router-dom';
import Input from '../../../shared/components/Input';
import Button from '../../../shared/components/Button';
import { useAuth } from '../hooks/useAuth';
import Alert from '../../../shared/components/Alert';

const schema = yup.object({
  email: yup.string().email('Invalid email').required('Email is required'),
});

const ForgotPasswordForm = () => {
  const { forgotPassword, isLoading, error, message, clearError, clearMessage } = useAuth();
  const { register, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {
    await forgotPassword(data.email);
  };

  return (
    <div className="max-w-md w-full mx-auto">
      <div className="text-center mb-8">
           <img 
  src="/avyukt-healthcare-logo.png" 
  alt="Logo" 
  className="mx-auto h-16 w-auto mb-4"
/>
        {/* <h2 className="text-3xl font-bold text-gray-900">Forgot Password</h2> */}
        <p className="text-gray-600 mt-2">
          Enter your email and we'll send you a reset link
        </p>
      </div>

      {error && (
        <Alert type="error" message={error} onClose={clearError} />
      )}

      {message && (
        <Alert type="success" message={message} onClose={clearMessage} />
      )}

      <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
        <Input
          label="Email Address"
          type="email"
          {...register('email')}
          error={errors.email?.message}
          placeholder="Enter your email"
        />

        <Button
          type="submit"
          variant="primary"
          isLoading={isLoading}
          className="w-full"
        >
          Send Reset Link
        </Button>
      </form>

      <p className="mt-6 text-center text-sm text-gray-600">
        Remember your password?{' '}
        <Link to="/login" className="text-blue-600 hover:text-blue-800 font-medium">
          Sign in
        </Link>
      </p>
    </div>
  );
};

export default ForgotPasswordForm;